import { getApiKey } from "../../../utils/apiKey";
import React, { useEffect, useState } from "react";
import Header from "../../header";
import Spinner from "../../Spinner/Spinner";
import { useHistory } from "routerCompat";
import { apiCall_domain } from "../../api";
import axios from "axios";
import { getCars, getShifts } from "../../../Services/emergency";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import PulseLoader from "react-spinners/PulseLoader";
import {
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { toast } from "react-hot-toast";
import LocationMap from "./Map";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "none",
  "border-radius": "8px",
  boxShadow: 24,
  p: 4,
  "max-height": "90vh",
  overflow: "scroll",
  "overflow-x": "hidden",
  "&::-webkit-scrollbar": {
    width: 0,
    background: "transparent",
  },
};

const Reserve = () => {
  const history = useHistory();

  let id = history.location.search.split("");
  id.splice(0, 1);
  id = id.join("");
  const [loading, setLoading] = useState(true);
  const [problems, setProblems] = useState();
  const [cars, setCars] = useState(null);
  const [chosenCar, setChosenCar] = useState(null);
  const [chosenProblem, setChosenProblem] = useState(null);
  const [installTimes, setInstallTimes] = useState();
  const [data, setData] = useState();
  const [chosenDay, setChosenDay] = useState();
  const [chosenHour, setChosenHour] = useState();
  const [description, setDescription] = useState();
  const [address, setAddress] = useState();
  const [type, setType] = useState();
  const [mapCordination, setMapCordination] = useState({});
  const [showMap, setShowMap] = useState(false);
  const [active, setActive] = useState();
  const [discountCode, setDiscountCode] = useState("");
  const [discountResponse, setDiscountResponse] = useState("");
  const [discountResponseStatus, setDiscountResponseStatus] = useState();
  const [confirmedDiscount, setConfirmedDiscount] = useState("");
  const [discountLoading, setDiscountLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [openType, setOpenType] = React.useState(false);
  const [openCar, setOpenCar] = React.useState(false);
  const [openDay, setOpenDay] = React.useState(false);
  const [openHour, setOpenHour] = React.useState(false);
  const handleOpenType = () => setOpenType(true);
  const handleCloseType = () => setOpenType(false);
  const handleOpenCar = () => setOpenCar(true);
  const handleCloseCar = () => setOpenCar(false);
  const handleOpenDay = () => setOpenDay(true);
  const handleCloseDay = () => setOpenDay(false);
  const handleOpenHour = () => setOpenHour(true);
  const handleCloseHour = () => setOpenHour(false);
  const [days, setDays] = useState([]);
  const [hours, setHours] = useState([]);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const handleShowmap = (condition) => {
    setShowMap(condition);
  };

  useEffect(() => {
    getCars().then((res) => {
      setCars(res.data.data);
      setLoading(false);
    });
    const headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    axios
      .post(
        `${apiCall_domain}/customer/mechanics/info`,
        { mechanic_id: id },
        { headers },
      )
      .then((res) => {
        setData(res.data.data);
        axios
          .get(
            `${apiCall_domain}/customer/mechanics/services?garage_id=${id}`,
            {
              headers,
            },
          )
          .then((res) => {
            setProblems(res.data.data);
          })
          .then((res) => {
            setLoading(false);
          });
      });
  }, []);
  useEffect(() => {
    getShifts(id, type).then((res) => {
      setDays(res.data.data);
    });
  }, [type]);
  const carHandler = (id) => {
    setChosenCar(id);
  };

  const problemHandler = (id) => {
    setChosenProblem(id);
  };
  const dayHandler = (value) => {
    setChosenDay(value);
    data?.days.map((day) =>
      +day.id === +value ? setInstallTimes(day.hours) : "",
    );
  };
  const timeHandler = (value) => {
    setChosenHour({ ...value });
  };
  const desHandler = (value) => {
    setDescription(value);
  };
  const addressHandler = (value) => {
    setAddress(value);
  };
  const submit = () => {
    setSubmitLoading(true);
    const data = {
      start_time: startTime,
      end_time: endTime,
      time: startTime,
      date: days?.find((day) => +chosenDay === +day.id).date,
      address: address,
      customer_car_id: chosenCar,
      day_id: chosenDay,
      description: description,
      garage_id: id,
      type: type,
      latitude: mapCordination.lat,
      longitude: mapCordination.lng,
      services: [chosenProblem],
      discount: confirmedDiscount,
    };
    const headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    axios
      .post(`${apiCall_domain}/customer/mechanics/book`, data, { headers })
      .then((res) => {
        toast.success("سرویس شما ثبت شد");
        history.push(`/services`);

        // window.location.href = "/services";
      })
      .finally(() => {
        setSubmitLoading(false);
      });
  };
  const changeMap = (latlng) => {
    setMapCordination(latlng);
  };

  const checkDiscount = () => {
    setDiscountLoading(true);
    const headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    axios
      .get(
        `${apiCall_domain}/customer/mechanics/checkDiscount?discount=${discountCode}&garage_id=${id}&service_id=${chosenProblem}`,
        { headers },
      )
      .then((res) => {
        setDiscountResponse(res.data.data.message);
        setDiscountResponseStatus(true);
        setConfirmedDiscount(discountCode);
      })
      .catch((err) => {
        // toast.error(err.response.data.message);
        setDiscountResponseStatus(false);
        setDiscountResponse(err.response.data.message);
      })
      .finally(() => {
        setDiscountLoading(false);
      });
  };
  return showMap ? (
    <LocationMap
      handleShowmap={() => {
        handleShowmap(false);
      }}
      changeMap={changeMap}
    />
  ) : (
    <>
      <Header showSearchBar={true} title={"رزرو سرویس"} />
      {loading ? (
        <Spinner />
      ) : (
        <>
          <div className="serviceItem">
            <div className="serviceType">
              <FormControl sx={{ width: "100%" }}>
                <FormLabel
                  id="demo-radio-buttons-group-label"
                  className="radioTitle"
                >
                  نوع سرویس
                </FormLabel>
                <RadioGroup
                  className="reservceRadioButtons"
                  sx={{ width: "100%" }}
                  row={true}
                  value={type}
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  onChange={(e) => {
                    setType(e.target.value);
                    setActive(e.target.value);
                  }}
                >
                  {data?.type === "both" ? (
                    <>
                      <FormControlLabel
                        className={`serviceTyperadioButton ${
                          active === "static" ? "activeRadio" : ""
                        }`}
                        value="static"
                        control={<Radio />}
                        label="ثابت"
                      />
                      <FormControlLabel
                        className={`serviceTyperadioButton ${
                          active === "dynamic" ? "activeRadio" : ""
                        }`}
                        value="dynamic"
                        control={<Radio />}
                        label="سیار"
                      />
                    </>
                  ) : data?.type === "static" ? (
                    <>
                      <FormControlLabel
                        className={`serviceTyperadioButton ${
                          active === "static" ? "activeRadio" : ""
                        }`}
                        value="static"
                        control={<Radio />}
                        label="ثابت"
                      />
                    </>
                  ) : (
                    <FormControlLabel
                      className={`serviceTyperadioButton ${
                        active === "dynamic" ? "activeRadio" : ""
                      }`}
                      value="dynamic"
                      control={<Radio />}
                      label="سیار"
                    />
                  )}
                </RadioGroup>
              </FormControl>
            </div>

            <div className="forms">
              <span>نوع خدمت</span>
              <div>
                <Button onClick={handleOpenType} className="form">
                  <div>
                    <span>
                      {chosenProblem
                        ? problems.map((problem) => (
                            <>
                              {+problem.id === +chosenProblem
                                ? problem.title
                                : ""}
                            </>
                          ))
                        : "خدمات قابل ارائه"}
                    </span>
                    <i className="icon-chevron-down" />
                  </div>
                </Button>
                <Modal
                  open={openType}
                  onClose={handleCloseType}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                    <Typography
                      id="modal-modal-description"
                      sx={{ mt: 2 }}
                      className="radioGroup"
                    >
                      <FormLabel
                        id="demo-radio-buttons-group-label"
                        className="radioGroupTitle"
                      >
                        <span>نوع خدمت</span>
                        <i className="icon-times" onClick={handleCloseType} />
                      </FormLabel>
                      <RadioGroup
                        className="reservceRadioButtons"
                        sx={{ width: "100%" }}
                        row={true}
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="static"
                        name="radio-buttons-group"
                        onChange={(e) => {
                          problemHandler(e.target.value);
                        }}
                      >
                        {problems?.map((item) => (
                          <FormControlLabel
                            className={`radioButton`}
                            value={item.id.toString()}
                            control={<Radio />}
                            label={item.title}
                          />
                        ))}
                        <div className="submitInfo" onClick={handleCloseType}>
                          ثبت
                        </div>
                      </RadioGroup>
                    </Typography>
                  </Box>
                </Modal>
              </div>

              {/* <FormControl sx={{ width: "100% !important" }}>
                <Select
                  sx={{ width: "100% !important" }}
                  onChange={(e) => {
                    problemHandler(e.target.value);
                  }}
                  name="car"
                  value={chosenProblem || "1st"}
                  displayEmpty
                >
                  <MenuItem value="1st">مهم نیست</MenuItem>
                  {problems?.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      <span> {item.title}</span>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}
            </div>
            <div className="forms">
              <span>انتخاب خودرو</span>
              <div>
                <Button onClick={handleOpenCar} className="form">
                  <div>
                    <span>
                      {chosenCar
                        ? cars.map((car) => (
                            <>{+chosenCar === car.id ? car.name : ""}</>
                          ))
                        : "خودرو های من"}
                    </span>
                    <i className="icon-chevron-down" />
                  </div>
                </Button>
                <Modal
                  open={openCar}
                  onClose={handleCloseCar}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                    <Typography
                      id="modal-modal-description"
                      sx={{ mt: 2 }}
                      className="radioGroup"
                    >
                      <FormLabel
                        id="demo-radio-buttons-group-label"
                        className="radioGroupTitle"
                      >
                        <span> خودرو های من</span>
                        <i className="icon-times" onClick={handleCloseCar} />
                      </FormLabel>
                      <RadioGroup
                        className="reservceRadioButtons"
                        sx={{ width: "100%" }}
                        row={true}
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="static"
                        name="radio-buttons-group"
                        onChange={(e) => {
                          carHandler(e.target.value);
                        }}
                      >
                        {cars?.map((car) => (
                          <FormControlLabel
                            className={`radioButton ${
                              openType === car.id ? "activeRadio" : ""
                            }`}
                            value={car.id.toString()}
                            control={<Radio />}
                            label={car.name}
                          />
                        ))}
                        <div className="submitInfo" onClick={handleCloseCar}>
                          ثبت
                        </div>
                      </RadioGroup>
                    </Typography>
                  </Box>
                </Modal>
              </div>
              {/* <FormControl sx={{ width: "100% !important" }}>
                <Select
                  sx={{ width: "100% !important" }}
                  onChange={(e) => {
                    carHandler(e.target.value);
                  }}
                  name="car"
                  value={chosenCar || "1st"}
                  displayEmpty
                >
                  <MenuItem value="1st">مهم نیست</MenuItem>
                  {cars.map((car) => (
                    <MenuItem key={car.id} value={car.id}>
                      <span> {car.name}</span>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}
            </div>
            <div className="description">
              <span>توضیحات</span>
              <textarea
                placeholder="توضیحات خود را اینجا بنویسید"
                value={description}
                onChange={(e) => {
                  desHandler(e.target.value);
                }}
              />
            </div>

            <div className="serviceInstallTimes">
              <span className="title">زمان سرویس</span>
              <div className="content">
                <div className="installTime">
                  <Button onClick={handleOpenDay} className="timeBtn">
                    <div className="timeTitle">
                      <span>
                        {chosenDay
                          ? days.map((day) => (
                              <>{+chosenDay === +day.id ? day.name : ""}</>
                            ))
                          : "روز"}
                      </span>
                      <i className="icon-chevron-down" />
                    </div>
                  </Button>
                  <Modal
                    open={openDay}
                    onClose={handleCloseDay}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box sx={style}>
                      <Typography
                        id="modal-modal-description"
                        sx={{ mt: 2 }}
                        className="radioGroup"
                      >
                        <FormLabel
                          id="demo-radio-buttons-group-label"
                          className="radioGroupTitle"
                        >
                          <span> روز سرویس</span>
                          <i className="icon-times" onClick={handleCloseDay} />
                        </FormLabel>
                        <RadioGroup
                          className="reservceRadioButtons"
                          sx={{ width: "100%" }}
                          row={true}
                          aria-labelledby="demo-radio-buttons-group-label"
                          name="radio-buttons-group"
                          onChange={(e) => {
                            dayHandler(e.target.value);
                          }}
                        >
                          {days.map((time) => (
                            <FormControlLabel
                              className={`radioButton`}
                              value={time.id}
                              onClick={() => {
                                setHours(time.hours);
                                handleCloseDay();
                                handleOpenHour();
                              }}
                              control={<Radio />}
                              label={time.name}
                            />
                          ))}
                        </RadioGroup>
                        <div className="submitInfo" onClick={handleCloseDay}>
                          ثبت
                        </div>
                      </Typography>
                    </Box>
                  </Modal>
                </div>
                <div className="installTime">
                  <Button onClick={handleOpenHour} className="timeBtn">
                    <div className="timeTitle">
                      <span>
                        {startTime && endTime
                          ? startTime + " - " + endTime
                          : " ساعت"}
                      </span>
                      <i className="icon-chevron-down" />
                    </div>
                  </Button>
                  <Modal
                    open={openHour}
                    onClose={handleCloseHour}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box sx={style}>
                      <Typography
                        id="modal-modal-description"
                        sx={{ mt: 2 }}
                        className="radioGroup"
                      >
                        <FormLabel
                          id="demo-radio-buttons-group-label"
                          className="radioGroupTitle"
                        >
                          <span>ساعت سرویس</span>
                          <i className="icon-times" onClick={handleCloseHour} />
                        </FormLabel>
                        <RadioGroup
                          className="reservceRadioButtons"
                          sx={{ width: "100%" }}
                          value={
                            hours.find(
                              (h) =>
                                `${h.start_time} ${h.end_time}` === chosenHour,
                            )?.id
                          }
                          row={true}
                          aria-labelledby="demo-radio-buttons-group-label"
                          name="radio-buttons-group"
                          onChange={(e) => {
                            timeHandler(e.target.value);
                          }}
                        >
                          {hours
                            .filter((h) => h.status === "open")
                            .map((hour) => (
                              <FormControlLabel
                                disabled={hour.status === "expired"}
                                className="radioButton"
                                value={`${hour.start_time} ${hour.end_time}`}
                                onClick={() => {
                                  timeHandler(hour);
                                  setStartTime(hour.start_time);
                                  setEndTime(hour.end_time);
                                }}
                                control={<Radio />}
                                label={`${hour.start_time} - ${hour.end_time}`}
                              />
                            ))}
                        </RadioGroup>
                        <div className="submitInfo" onClick={handleCloseHour}>
                          ثبت
                        </div>
                      </Typography>
                    </Box>
                  </Modal>
                  {/* <Select
                    displayEmpty
                    sx={{
                      width: "100%",
                      borderRadius: "8px",
                      boxShadow: "none",
                    }}
                    value={chosenHour || "1st"}
                    name="hour"
                    className="timeSelectBox"
                    onChange={(e) => {
                      timeHandler(e.target.value);
                    }}
                  >
                    <MenuItem value="1st" disabled>
                      انتخاب ساعت
                    </MenuItem>
                    {installTimes &&
                      installTimes.map((hour, index) => (
                        <MenuItem value={hour} key={index}>
                          {hour}
                        </MenuItem>
                      ))}
                  </Select> */}
                </div>
              </div>
            </div>
            {type !== "static" ? (
              <>
                <div className="description">
                  <span>ادرس</span>
                  <textarea
                    placeholder="آدرس دقیق خود را به صورت کامل یادداشت کنید"
                    value={address}
                    onChange={(e) => {
                      addressHandler(e.target.value);
                    }}
                  />
                </div>
                <div
                  className="DetailMap"
                  onClick={() => {
                    handleShowmap(true);
                  }}
                >
                  <img
                    src="/public/assets/map.jpg"
                    className="Mapbody"
                    alt="map"
                  />
                  <img
                    src="/public/assets/icons/locationInMap.svg"
                    className="LocationMap"
                    alt="location"
                  />
                  <span>موقعیت آدرس را روی نقشه مشخص کنید</span>
                </div>
              </>
            ) : null}
            {/* {error ? <span>{error}</span> : null} */}
            <div className="discountSection">
              <span className="discountTitle">کد تخفیف</span>
              <div>
                <input
                  type="text"
                  placeholder="اگر کد تخفیفی از این وندور یا کاچار دارید وارد کنید"
                  onChange={(e) => {
                    setDiscountCode(e.target.value);
                  }}
                />
                <button onClick={checkDiscount}>
                  {discountLoading ? (
                    <PulseLoader color="#3C8179" size={10} />
                  ) : (
                    "ثبت کد"
                  )}
                </button>
              </div>
              {discountResponse ? (
                <span
                  className={`discountResponse ${
                    discountResponseStatus ? "green" : "red"
                  }`}
                >
                  {discountResponse}
                </span>
              ) : (
                <></>
              )}
            </div>
            <div className="reserveService" onClick={submit}>
              {submitLoading ? <PulseLoader color="#fff" size={12} /> : "رزرو"}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Reserve;
